import React, { useState } from 'react';
import { Box, Typography, Tabs, Tab } from '@mui/material';
import CreateProjectTab from '../components/projects/CreateProjectTab';
import ViewProjectsTab from '../components/projects/ViewProjectsTab';

export default function Projects() {
  const [currentTab, setCurrentTab] = useState(0);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  const handleProjectCreated = () => {
    // Switch to view tab and refresh the list
    setCurrentTab(1);
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <Box>
      <Typography variant="h4" gutterBottom sx={{ fontWeight: 600 }}>
        Projects
      </Typography>

      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs value={currentTab} onChange={handleTabChange}>
          <Tab label="Create New Project" />
          <Tab label="View Existing Projects" />
        </Tabs>
      </Box>

      {currentTab === 0 && (
        <CreateProjectTab onProjectCreated={handleProjectCreated} />
      )}

      {currentTab === 1 && (
        <ViewProjectsTab refreshTrigger={refreshTrigger} />
      )}
    </Box>
  );
}
